<template>
    <p-secure :require-role="[SECURITYROLES.STOREMANAGER]">
        <div v-if="account">
            <p-card>
                
                <p-search-table
                    api-destination="accountreceivable"
                    search-destination="customersearch"
                    ref="searchTable"
                    :filters="filters"
                    :per-page="100"
                    :fields="fields"
                    edit-key="customerId"
                    add-bulk-is-active-toggle
                    :show-set-to="false"
                    :use-bootstrap-selection="false"
                    v-model="selectedCustomers"
                >
                    <template v-slot:above-search>
                        <b-row class="mb-3">
                            <b-col class="d-flex align-items-center gap-2">
                            <CustomerAccountDetails
                                buttonLabel="Link Customer"
                                id="new"
                                :customerId="0"
                                :account="account"
                                @result-updated="refreshTable"
                            />

                            <p-button
                                variant="outline-primary"
                                :is-busy="isBusy"
                                @click="unlinkCustomers()"
                            >
                                Unlink
                            </p-button>
                            <p-button
                                variant="outline-primary"
                                :is-busy="isBusy"
                                @click="clearFunding()">
                                Clear Funding
                            </p-button>
                            </b-col>
                        </b-row>
                    </template>

                    <template v-slot:cell(fullName)="{ item }">
                        {{ item.lastName }}
                    </template>

                    <template v-slot:cell(edit)="{ item }">
                        <CustomerAccountDetails
                            buttonLabel="Edit"
                            :id="item.customerId.toString()"
                            :customerId="item.customerId"
                            :details="item"
                            :account="account"
                            @result-updated="refreshTable"
                        />
                    </template>

                    <template v-slot:cell(customerId)="{ item }">
                        <router-link :to="'/customers/' + item.customerId">
                            {{ item.customerAccount }}
                        </router-link>
                    </template>
                </p-search-table>
            </p-card>
        </div>
    </p-secure>
</template>

<script>
import { dateFormatter, currencyFormatter } from '../../components/Common/Formatters.js';
import CustomerAccountDetails from './CustomerAccountDetails.vue';
import axios from 'axios';

export default {
    props: {
        customers: Object,
        account: Object
    },
    methods: {
        unlinkCustomers() {
            if (this.selectedCustomers.length === 0) {
                this.$bvModal.msgBoxOk(`Please select a customer to unlink.`);
            } else {
                this.$bvModal
                    .msgBoxConfirm(
                        'This action will disable access to the selected customer. Select OK to continue.'
                    )
                    .then(value => {
                        if (value) {
                            this.isBusy = true;

                            const body = {
                                accountId: this.account.accountId,
                                customerIds: this.selectedCustomers.map(
                                    cust => cust.customerId
                                )
                            };

                            axios
                                .post('AccountReceivable/linkunlink', body)
                                .then(() => {
                                    this.isBusy = false;
                                    this.selectedCustomers = [];
                                    // Clearing the v-model alone doesn't reset the
                                    // table's internal selectedRows (no modelValue
                                    // sync), so the selected-count label sticks.
                                    // Reset the table's own selection state too.
                                    this.$refs.searchTable.clearSelectedRows();
                                    this.$refs.searchTable.refreshSearchResults();
                                })
                                .finally(() => {
                                    this.isBusy = false;
                                });
                        }
                    });
            }
        },
        clearFunding() {
            this.$bvModal
                .msgBoxConfirm('This action will clear all funding for linked accounts. To allow future purchasing, credit limits and/or balances must be re-established. Are you sure you want to continue?',
                {
                    okTitle: 'Continue',
                })
                .then(value => {
                    if (value) {
                        this.isBusy = true;

                        axios.post('accountreceivable/clearfunding', { accountId: this.account.accountId })
                            .then(() => {
                                this.isBusy = false;
                                this.$refs.searchTable.refreshSearchResults();
                            })
                            .finally(() => {
                                this.isBusy = false;
                            });
                    }
                });
        },
        refreshTable() {
            this.$refs?.searchTable.refreshSearchResults();
            this.$emit('load-data');
        }
    },
    data() {
        return {
            filterName: 'CustomersFilter',
            selectedCustomers: [],
            isBusy: false,
            filters: {
                automatic: '',
                searchBy: 'All',
                AccountId: this.account.accountId,
                options: ['All', 'Customer Account', 'Last Name', 'Email']
            },
            fields: [
                {
                    label: '',
                    key: 'edit'
                },
                {
                    label: 'Last Name',
                    key: 'lastName',
                    sortable: true
                },
                {
                    label: 'First Name',
                    key: 'firstName'
                },
                {
                    label: 'Customer Account',
                    key: 'customerId',
                    sortable: true,
                },
                {
                    label: 'Email',
                    key: 'email',
                    sortable: true
                },
                {
                    label: 'Start Date',
                    key: 'startDate',
                    sortable: true,
                    formatter: dateFormatter
                },
                {
                    label: 'End Date',
                    key: 'endDate',
                    sortable: true,
                    formatter: dateFormatter
                },
                {
                    label: 'Available Funds',
                    key: 'availableFunds',                    
                    formatter: currencyFormatter,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    label: 'Comment',
                    key: 'comments'
                }
            ]
        };
    },
    components: {
        CustomerAccountDetails
    }
};
</script>

<style scoped></style>
